const e=e=>null!==e;function o(o,{repeat:t,repeatType:n="loop"},l){const p=o.filter(e),r=t&&"loop"!==n&&t%2==1?0:p.length-1;return r&&void 0!==l?l:p[r]}export{o as getFinalKeyframe};
